import { CustomWindow } from '@utils/models/customwindow';
import { IYouTube } from './IYouTube';

declare let window: CustomWindow;

let youTubeObject: IYouTube = {
  initialized: false,
  players: [],

  initialize: function() {
    if (!this.initialized && !!window.Cookiebot && !!window.Cookiebot.consent && window.Cookiebot.consent.marketing && !document.getElementById("youtube-iframe-api")) {
      let anyYouTubePlayers = document.querySelectorAll(".video__content--youtube").length;

      if (!!anyYouTubePlayers) {
        let tag = document.createElement("script");
        let firstScriptTag = document.querySelector("script");

        tag.src = "https://www.youtube.com/iframe_api";
        tag.id = "youtube-iframe-api";

        if (!!firstScriptTag) {
          firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
          this.initialized = true;
        }
      }
    }
  },

  createPlayer: function(videoId: string | undefined, ytPlayerId: string | undefined, onPlayerStateChange: Function, autoPlay: boolean) {
    let videoContentElement = document.querySelector(`[data-containerid='${ytPlayerId}']`) as HTMLDivElement;

    if (!videoContentElement?.dataset?.video) {
      return;
    }
    
    let jsonVideoSettings = videoContentElement.dataset.video as string;
    let parsedJsonVideoSettings = JSON.parse(jsonVideoSettings);
    
    let player = new window.YT.Player(ytPlayerId, {
      videoId: videoId,
      playerVars: {
        "playsinline": 1,
        'autoplay': parsedJsonVideoSettings["autoplay"],
        'controls': parsedJsonVideoSettings["showcontrols"],
        'fs': parsedJsonVideoSettings["showfullscreenoption"],
        'loop': parsedJsonVideoSettings["loop"],
        'playlist': videoId,
        'rel': parsedJsonVideoSettings["showrelatedcontent"] || 0,
        'mute': parsedJsonVideoSettings["autoplay"] || parsedJsonVideoSettings["mute"]
      },
      events: {
        "onReady": (event: any) => {
          if (document.querySelector("body")?.classList.contains("isIOS")) {
            event.target.mute();
          }

          if (autoPlay) {
            event.target.playVideo();
          }

          window.iframeLoadedHandler(player.getIframe());
        },
        "onStateChange": (event: any) => {
          onPlayerStateChange(event, ytPlayerId)
        }
      }
    });

    this.players.push({ytPlayerId: ytPlayerId, player: player});
  },

  playYouTubeVideo: function(blockElement: any) {
    let playerObject: any = this.players.find((x: {
      ytPlayerId: string | undefined,
      player: any
    }) => x.ytPlayerId == blockElement.dataset.ytplayerid);

    if (!!playerObject) {
      playerObject.player.playVideo();
    }
  }
}

// Stage 3: If this script was loaded before YouTube related scripts, dispatch the loaded event again
document.addEventListener('YouTubeRelatedScriptLoaded', function(e) {
  document.dispatchEvent(new CustomEvent("YouTubeScriptLoaded"));
});

window.KnowitOptimizelyFramework.YouTube = youTubeObject;

// Tell other modules that this script is loaded
document.dispatchEvent(new CustomEvent("YouTubeScriptLoaded"));